module.exports = __webpack_public_path__ + "static/media/ret-dashboard-icon.ba8030bb.svg";